import { Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { deCamelize, formatCurrency } from '@shared/commonFunctions';
import { dataGridCol } from '@shared/components/grid/common';
import { FieldType } from './interfaces/interfaces';

export const ColumnNames = {
  Employment: [
    { name: 'companyName' },
    { name: 'dateReported' },
    { name: 'dateSeparated' },
    { name: 'income', type: FieldType.currency },
    { name: 'jobTitle' },
  ],
  'Student Loan': [
    { name: 'creditorName' },
    { name: 'originalAmount', type: FieldType.currency },
    { name: 'term' },
    { name: 'balance', type: FieldType.currency },
    { name: 'payment', type: FieldType.currency },
    { name: 'monthsRemaining' },
    { name: 'status' },
    { name: 'estApr' },
    { name: 'coSigner' },
  ],
  'Auto Summary': [
    { name: 'creditorName' },
    { name: 'originalAmount', type: FieldType.currency },
    { name: 'term' },
    { name: 'balance', type: FieldType.currency },
    { name: 'payment', type: FieldType.currency },
    { name: 'monthsRemaining' },
    { name: 'status' },
    { name: 'estApr' },
    { name: 'coSigner' },
  ],
  Inquiries: [
    { name: 'date' },
    { name: 'subscriberName' },
    { name: 'subscriberNumber' },
    { name: 'amount', type: FieldType.currency },
    { name: 'market' },
    { name: 'submarket' },
    { name: 'kob' },
  ],
  'Trade-Line': [
    { name: 'firmName' },
    { name: 'firmID' },
    { name: 'accountNumber' },
    { name: 'kob' },
    { name: 'tradeType' },
    { name: 'status' },
    { name: 'dateOpened' },
    { name: 'dateReported' },
    { name: 'accountType' },
    { name: 'creditLimit', type: FieldType.currency },
    { name: 'highCredit', type: FieldType.currency },
    { name: 'chargeOff', type: FieldType.currency},
    { name: 'dateLastPayment' },
    { name: 'balance', type: FieldType.currency },
    { name: 'pastDue', type: FieldType.currency },
    { name: 'originalLoanValue', type: FieldType.currency },
    { name: 'closedIndicator' },
    { name: 'monthlyPayment', type: FieldType.currency },
    { name: 'monthlyRepayment', type: FieldType.currency},
    { name: 'dateClosed' },
    { name: 'owner' },
    { name: 'past30Days' },
    { name: 'past60Days' },
    { name: 'past90Days' },
    { name: 'paymentPattern' },
    { name: 'terms' },
    { name: 'recordCode' },
    { name: 'dateLastActivity' },
  ],
};

export const CreditReportGridColumns = (tableName: string) => {
  return ColumnNames[tableName as keyof typeof ColumnNames].map((obj) => {
    const renderHeader = () => (
      <Typography whiteSpace="normal" fontWeight="bold">
        {deCamelize(obj.name)}
      </Typography>
    );

    const renderCell = ({ value }: GridRenderCellParams) => (
      <Typography whiteSpace="normal">{obj.type === FieldType.currency && !isNaN(value) ? formatCurrency(value) : value}</Typography>
    );

    return dataGridCol(obj.name, {
      flex: 1,
      sortable: true,
      renderHeader,
      renderCell,
    });
  });
};